import React from 'react';
import { useTranslate } from '../../../mixins/translate/translate';
import { EditPanelButtons, EditPanelButton } from '../../elements';
import { Modal } from './Modal';

type ModalFormProps = {
    onClose: () => void;
    title: string;
    children: React.ReactNode;
    cancelButton: {
        textOverride?: string | undefined;
        onClick: () => void;
    };
    saveButton: {
        textOverride?: string | undefined;
        onClick: (() => void) | (() => Promise<void>);
        disabled?: boolean | undefined;
    };
};

export function ModalForm(props: ModalFormProps) {
    const translate = useTranslate();

    return (
        <Modal id="dialog" onClose={props.onClose}>
            <Modal.Title>
                <h3>
                    <span className="panel-title">{props.title}</span>
                </h3>
            </Modal.Title>

            <Modal.Content style={{ height: `${350}px` }}>
                <div className="admin-form" style={{ width: '100%' }}>
                    {props.children}
                </div>
            </Modal.Content>

            <Modal.Actions>
                <EditPanelButtons fixWidth={true}>
                    <EditPanelButton
                        small={true}
                        text={props.cancelButton.textOverride ?? translate('common.cancel')}
                        onClick={props.cancelButton.onClick}
                    />
                    <EditPanelButton
                        small={true}
                        text={props.saveButton.textOverride ?? translate('common.update')}
                        onClick={props.saveButton.onClick}
                        primary
                        disabled={props.saveButton.disabled}
                    />
                </EditPanelButtons>
            </Modal.Actions>
        </Modal>
    );
}
